import { SimpleModal } from "../../components";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { OrderTransport } from "src/app/transports/order";
import { IActionsModal } from "src/app/types/actionsModal";
import { Order } from "src/app/types/orders/order";

const ApproveOrderModalContainer = (props: IActionsModal<Order>) => {
    const { handleClose = () => {}, entity, updateGridOnSave = () => {} } = props;
    const [loading, setLoading] = useState(false);
    const { formatMessage } = useIntl();

    const handleSubmit = async () => {
        setLoading(true);

        const tranformedData = OrderTransport.formTransformer(entity);

        if (!tranformedData) return;
        try {
            const res = await OrderTransport.save(
                { ...tranformedData, isApproved: true },
                entity?.id
            );
            await updateGridOnSave(res, false);
            toast.success(formatMessage({ id: "common.notification.success" }));
            setLoading(false);
            handleClose();
        } catch (error: any) {
            setLoading(false);
            toast.error(formatMessage({ id: "common.notification.error" }));
        }
        setLoading(false);
    };
    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.entity.approve" })}
            handleClose={handleClose}
            loading={loading}
            formId=""
            buttonConfirmationLabel={formatMessage({ id: "common.action.confirmation" })}
            buttonConfirmationAction={handleSubmit}
            showModal={true}
            modalProps={{ size: "lg" }}
        >
            <>
                <div className="d-flex gap-2">
                    <b>{formatMessage({ id: "common.field.moneySite" })}:</b>
                    <span>{entity?.moneySite?.domain}</span>
                </div>
                {entity?.platform && (
                    <div className="d-flex gap-2">
                        <b>{formatMessage({ id: "common.field.platform" })}:</b>
                        <span>{entity?.platform.name}</span>
                    </div>
                )}

                {entity?.links && (
                    <div className="d-flex gap-2">
                        <b>{formatMessage({ id: "common.field.links" })}:</b>
                        <span>{`${entity?.links[0]?.url} (${entity?.links[0]?.anchor})`}</span>
                    </div>
                )}
            </>
        </SimpleModal>
    );
};

export default ApproveOrderModalContainer;
